import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { showError, showToast } from "../constants/toasts";

interface RejectReasonModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onSubmit: (reason: string) => void;
}

export default function RejectReasonModal({
  open,
  onClose,
  setOpen,
  onSubmit,
}: RejectReasonModalProps) {
  const [reason, setReason] = useState("");

  const handleSubmit = () => {
    if (!reason) {
      showError("Please add reason");
    } else {
      onSubmit(reason);
      setReason("");
    }
  };

  const handleClose = () => {
    setOpen(false);
    setReason("");
  };

  return (
    <Modal
      className="modal rejectReason_modal"
      open={open}
      onClose={handleClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Rejection Reason</h2>
            <div className="btn-close" onClick={handleClose}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <label>Add Reason</label>
              <TextField
                placeholder="Enter Reason"
                fullWidth
                hiddenLabel
                multiline
                maxRows={5}
                minRows={5}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="btn btn_primary" onClick={handleSubmit}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
